import React from "react";
export default function ProfileInput({
  type,
  name,
  id,
  placeholder,
  errors = [],
  label,
  defaultValue = "",
  disabled,
  inputClass = "",
  showLabel = true,
  register = () => {},
}) {
  return (
    <div className="">
      {showLabel && <label className="mb-2 text-white">{label}</label>}
      <input
        disabled={disabled}
        defaultValue={defaultValue}
        type={type}
        id={id}
        placeholder={placeholder}
        className={`w-full rounded-md bg-[#384355] text-white border-borderGray hover:border-primaryBlue focus:border-primaryBlue focus:outline-none active:border-primaryBlue mt-2 border-2 p-3 text-sm placeholder-gray-400 ${inputClass}`}
        {...register(name)}
      />
      {errors[name] && (
        <p className="text-red-400 mt-2 text-base md:text-base text-left ml-1">
          {errors[name]?.message}
        </p>
      )}
    </div>
  );
}
